import { makeAutoObservable } from 'mobx';

export default class CutShapePatent {
  country = '';

  patentUrl = '';

  title = '';

  setCountry = (country: string) => {
    this.country = country;
  };

  setPatentUrl = (patentUrl: string) => {
    this.patentUrl = patentUrl;
  };

  setTitle = (title: string) => {
    this.title = title;
  };

  constructor() {
    makeAutoObservable(this);
  }

  isFilled() {
    return this.country.trim().length > 0 && this.patentUrl.trim().length > 0 && this.title.length > 0;
  }
}
